'use client';

import { useState } from 'react';
import { Copy01Icon, Tick01Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { IconButton } from '../../../components/icon-button';
import { Tooltip } from '../../../components/tooltip';

const COPIED_FEEDBACK_MS = 1500;

export function CliCopyButton({ text }: { text: string }) {
  const tCommon = useTranslations('designSystem.common');
  const [copied, setCopied] = useState(false);
  const copyText = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        window.setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
      })
      .catch((error: unknown) => {
        console.warn('Failed to copy terminal text to the clipboard', error);
      });
  };

  return (
    <Tooltip title={tCommon('copy')} openDelay={300}>
      <IconButton
        variant="ghost"
        size="2xs"
        aria-label={tCommon('copy')}
        color={copied ? 'fg.success' : 'fg.muted'}
        _hover={{ color: 'fg.default' }}
        onClick={(event) => {
          event.stopPropagation();
          copyText();
        }}
      >
        {copied ? <Tick01Icon size={12} /> : <Copy01Icon size={12} />}
      </IconButton>
    </Tooltip>
  );
}
